/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
};

export type Account = {
  customer: Customer;
  hasRestrictedAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  managerId: Scalars['ID'];
  number: Scalars['String'];
};

export type AccountEdge = {
  __typename: 'AccountEdge';
  node: Account;
};

export type AccountFiltersInput = {
  id?: InputMaybe<AccountFiltersInputId>;
};

export type AccountFiltersInputId = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

export enum AccountQualityEnum {
  CoOwner = 'CO_OWNER',
  Landlord = 'LANDLORD',
  Tenant = 'TENANT'
}

export type AccountsResponse = {
  __typename: 'AccountsResponse';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
};

export type Address = {
  __typename: 'Address';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type Agency = {
  __typename: 'Agency';
  id: Scalars['ID'];
};

export type Amount = {
  __typename: 'Amount';
  currency: Currency;
  value: Scalars['Int'];
};

export type AmountInput = {
  currency: Currency;
  value: Scalars['Int'];
};

export type AmountVat = {
  __typename: 'AmountVAT';
  currency: Currency;
  taxExcluded: Scalars['Int'];
  taxIncluded: Scalars['Int'];
  vatRate: Scalars['Float'];
};

export type AmountVatInput = {
  currency: Currency;
  taxExcluded: Scalars['Int'];
  taxIncluded: Scalars['Int'];
  vatRate: Scalars['Float'];
};

export type Authentication = {
  __typename: 'Authentication';
  customer: Customer;
  isTemporaryLogin: Scalars['Boolean'];
  login: Scalars['String'];
};

export type BackwardCursorInput = {
  before: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
};

export type Birth = {
  __typename: 'Birth';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
};

export type Brand = {
  __typename: 'Brand';
  code: Scalars['String'];
  customerPortal: CustomerPortal;
  dataProtectionPolicy: BrandDataProtectionPolicy;
  email: BrandEmail;
  id: Scalars['ID'];
  identity: BrandIdentity;
  payment: BrandPayment;
  registeredEmailService?: Maybe<BrandRegisteredEmailService>;
};

export type BrandCustomerPortalAssistance = {
  __typename: 'BrandCustomerPortalAssistance';
  hours: Scalars['String'];
  phone: Scalars['String'];
};

export type BrandCustomerPortalGuideDocument = {
  __typename: 'BrandCustomerPortalGuideDocument';
  mimeType: Scalars['String'];
  originalFilename: Scalars['String'];
  qualities: Array<AccountQualityEnum>;
  url: Scalars['String'];
};

export type BrandCustomerPortalGuides = {
  __typename: 'BrandCustomerPortalGuides';
  propertyTaxFillingGuide?: Maybe<BrandCustomerPortalGuideDocument>;
  trusteeCouncilGuideUrl?: Maybe<Scalars['String']>;
  userGuides?: Maybe<BrandCustomerPortalUserGuides>;
};

export type BrandCustomerPortalMobileApp = {
  __typename: 'BrandCustomerPortalMobileApp';
  appStoreUrl: Scalars['String'];
  googlePlayStoreUrl: Scalars['String'];
};

export type BrandCustomerPortalUserGuides = {
  __typename: 'BrandCustomerPortalUserGuides';
  categoryName: Scalars['String'];
  documents?: Maybe<Array<BrandCustomerPortalGuideDocument>>;
};

export type BrandDataProtectionPolicy = {
  __typename: 'BrandDataProtectionPolicy';
  email: Scalars['String'];
  formUrl: Scalars['String'];
  url: Scalars['String'];
};

export type BrandEmail = {
  __typename: 'BrandEmail';
  emailFrom: Scalars['String'];
  welcomeHeaderColor: Scalars['String'];
  welcomeHeaderUrl: Scalars['String'];
};

export type BrandIdentity = {
  __typename: 'BrandIdentity';
  logoUrl: Scalars['String'];
  name: Scalars['String'];
};

export type BrandNotFoundError = Error & {
  __typename: 'BrandNotFoundError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type BrandPayment = {
  __typename: 'BrandPayment';
  hasAutomaticDirectDebit: Scalars['Boolean'];
  hasOnDemandDirectDebit: Scalars['Boolean'];
};

export type BrandRegisteredEmailService = {
  __typename: 'BrandRegisteredEmailService';
  name: Scalars['String'];
};

export type Building = {
  __typename: 'Building';
  address: Address;
  buildingName: Scalars['String'];
  buildingNumber: Scalars['String'];
  id: Scalars['ID'];
  pricings: Array<BuildingPricing>;
};


export type BuildingPricingsArgs = {
  coOwnershipMandateId: Scalars['String'];
};

export type BuildingPricing = {
  __typename: 'BuildingPricing';
  amount?: Maybe<AmountVat>;
  codification: Scalars['String'];
};

export type CoOwnerAccount = Account & {
  __typename: 'CoOwnerAccount';
  building: Building;
  customer: Customer;
  guides: Array<Guide>;
  hasAccessToGeneralAssembly: Scalars['Boolean'];
  hasActiveCoOwnershipMandate: Scalars['Boolean'];
  hasRestrictedAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  isTrusteeCouncilMember: Scalars['Boolean'];
  managerId: Scalars['ID'];
  missionIncidents: MissionIncidentsResponse;
  number: Scalars['String'];
  registeredEmail: RegisteredEmail;
  units: Array<Unit>;
};


export type CoOwnerAccountMissionIncidentsArgs = {
  cursor?: InputMaybe<CursorInput>;
  sortBy?: InputMaybe<Array<MissionIncidentSortInput>>;
};

export type ComputeExpectedLessorPropertyTaxInput = {
  fiscalYear: Scalars['Int'];
  lessorAccountId: Scalars['ID'];
};

export type Coordinates = {
  __typename: 'Coordinates';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CreateLessorPropertyTaxInput = {
  areAllBuildingsManagedByAgency: Scalars['Boolean'];
  buildings: Array<LessorPropertyTaxBuildingInput>;
  fileId: Scalars['String'];
  fiscalManagementFees: AmountInput;
  fiscalYear: Scalars['Int'];
  lessorAccountId: Scalars['ID'];
  total: AmountInput;
};

export enum Currency {
  All = 'ALL',
  Bgn = 'BGN',
  Byn = 'BYN',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Czk = 'CZK',
  Eur = 'EUR',
  Isk = 'ISK',
  Jpy = 'JPY',
  Mdl = 'MDL',
  Nok = 'NOK',
  Pln = 'PLN',
  Ron = 'RON',
  Rsd = 'RSD',
  Sek = 'SEK',
  Usd = 'USD'
}

export type CursorInput = {
  backward?: InputMaybe<BackwardCursorInput>;
  forward?: InputMaybe<ForwardCursorInput>;
};

export type Customer = {
  address?: Maybe<Address>;
  birth?: Maybe<Birth>;
  consent: CustomerConsent;
  customerNumber: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landlinePhone?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  professionalPhone?: Maybe<Scalars['String']>;
};

export type CustomerCompany = Customer & {
  __typename: 'CustomerCompany';
  address?: Maybe<Address>;
  birth?: Maybe<Birth>;
  companyName?: Maybe<Scalars['String']>;
  consent: CustomerConsent;
  customerNumber: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landlinePhone?: Maybe<Scalars['String']>;
  legalRepresentative?: Maybe<LegalRepresentative>;
  mobilePhone?: Maybe<Scalars['String']>;
  professionalPhone?: Maybe<Scalars['String']>;
};

export type CustomerConsent = {
  __typename: 'CustomerConsent';
  customerUpdatedAt?: Maybe<Scalars['DateTime']>;
  partnersOffersInformation: Scalars['Boolean'];
  personalData: Scalars['Boolean'];
};

export type CustomerPerson = Customer & {
  __typename: 'CustomerPerson';
  address?: Maybe<Address>;
  birth?: Maybe<Birth>;
  civility?: Maybe<Scalars['String']>;
  consent: CustomerConsent;
  customerNumber: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  landlinePhone?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  mobilePhone?: Maybe<Scalars['String']>;
  professionalPhone?: Maybe<Scalars['String']>;
};

export type CustomerPortal = {
  __typename: 'CustomerPortal';
  assistance?: Maybe<BrandCustomerPortalAssistance>;
  displayUrl: Scalars['String'];
  guides?: Maybe<BrandCustomerPortalGuides>;
  logoUrl: Scalars['String'];
  mobileApp?: Maybe<BrandCustomerPortalMobileApp>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CustomerPortalWorkOrder = {
  __typename: 'CustomerPortalWorkOrder';
  id: Scalars['ID'];
  label: Scalars['String'];
  number: Scalars['String'];
  repairDate?: Maybe<CustomerPortalWorkOrderRepairDate>;
  supplier?: Maybe<CustomerPortalWorkOrderSupplier>;
};

export type CustomerPortalWorkOrderEdge = {
  __typename: 'CustomerPortalWorkOrderEdge';
  node: CustomerPortalWorkOrder;
};

export type CustomerPortalWorkOrderRepairDate = {
  __typename: 'CustomerPortalWorkOrderRepairDate';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type CustomerPortalWorkOrderSupplier = {
  __typename: 'CustomerPortalWorkOrderSupplier';
  activity?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
};

export type CustomerPortalWorkOrdersResponse = {
  __typename: 'CustomerPortalWorkOrdersResponse';
  edges: Array<CustomerPortalWorkOrderEdge>;
  pageInfo: PageInfo;
};

export type Error = {
  message: Scalars['String'];
};

export type ExpectedLessorPropertyTax = {
  __typename: 'ExpectedLessorPropertyTax';
  agency?: Maybe<Agency>;
  buildings: Array<ExpectedLessorPropertyTaxBuilding>;
  fiscalYear: Scalars['Int'];
  id: Scalars['ID'];
};

export type ExpectedLessorPropertyTaxBuilding = {
  __typename: 'ExpectedLessorPropertyTaxBuilding';
  building: Building;
  lessorPropertyTaxBuildingId?: Maybe<Scalars['String']>;
  lessorPropertyTaxId?: Maybe<Scalars['String']>;
};

export type ExpectedLessorPropertyTaxComputeProgress = {
  __typename: 'ExpectedLessorPropertyTaxComputeProgress';
  computeProgress: ExpectedLessorPropertyTaxeComputeProgressStatus;
};

export type ExpectedLessorPropertyTaxEdge = {
  __typename: 'ExpectedLessorPropertyTaxEdge';
  node: ExpectedLessorPropertyTax;
};

export type ExpectedLessorPropertyTaxFiscalYear = {
  __typename: 'ExpectedLessorPropertyTaxFiscalYear';
  fiscalYear: Scalars['Int'];
  status: ExpectedLessorPropertyTaxFiscalYearStatusEnum;
};

export enum ExpectedLessorPropertyTaxFiscalYearStatusEnum {
  Completed = 'COMPLETED',
  Computed = 'COMPUTED',
  Invalid = 'INVALID',
  Undefined = 'UNDEFINED'
}

export enum ExpectedLessorPropertyTaxeComputeProgressStatus {
  Done = 'DONE',
  Error = 'ERROR',
  Invalid = 'INVALID',
  Pending = 'PENDING'
}

export type ExpectedLessorPropertyTaxesResponse = {
  __typename: 'ExpectedLessorPropertyTaxesResponse';
  edges: Array<ExpectedLessorPropertyTaxEdge>;
  pageInfo: PageInfo;
};

export enum FamilyStatus {
  CivilUnion = 'CIVIL_UNION',
  Divorce = 'DIVORCE',
  DomesticPartners = 'DOMESTIC_PARTNERS',
  Married = 'MARRIED',
  Other = 'OTHER',
  Separate = 'SEPARATE',
  Single = 'SINGLE',
  Townhall = 'TOWNHALL',
  Widower = 'WIDOWER'
}

export type ForwardCursorInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type GetPostalVoteSignature = {
  __typename: 'GetPostalVoteSignature';
  document?: Maybe<PostalVoteDocument>;
  signUrl?: Maybe<Scalars['String']>;
  signatoryId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type Guide = {
  __typename: 'Guide';
  mimeType: Scalars['String'];
  originalFilename: Scalars['String'];
  url: Scalars['String'];
};

export type Lease = {
  __typename: 'Lease';
  building?: Maybe<Building>;
  entryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  leaveDate?: Maybe<Scalars['DateTime']>;
  needHeatingCertificate?: Maybe<Scalars['Boolean']>;
  status: LeaseStatus;
  tenantBalance?: Maybe<LeaseTenantBalance>;
  tenants: Array<LeaseTenantInformation>;
  units: Array<LeaseUnitInformation>;
};

export type LeaseEdge = {
  __typename: 'LeaseEdge';
  node: Lease;
};

export type LeaseFiltersInputStatus = {
  eq?: InputMaybe<LeaseStatus>;
  in?: InputMaybe<Array<LeaseStatus>>;
  nin?: InputMaybe<Array<LeaseStatus>>;
};

export type LeaseInsuranceMultiriskUnitBody = {
  __typename: 'LeaseInsuranceMultiriskUnitBody';
  companyName: Scalars['String'];
  policyNumber: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
};

export enum LeaseStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  LeaseEntryOngoing = 'LEASE_ENTRY_ONGOING',
  LeaseEntryToDo = 'LEASE_ENTRY_TO_DO',
  LeaseEntryToValidate = 'LEASE_ENTRY_TO_VALIDATE',
  RentalOnly = 'RENTAL_ONLY',
  SigningIssue = 'SIGNING_ISSUE',
  TenantLeaveBalanceAdditionalTodo = 'TENANT_LEAVE_BALANCE_ADDITIONAL_TODO',
  TenantLeaveBalanceDone = 'TENANT_LEAVE_BALANCE_DONE',
  TenantLeaveBalanceToDo = 'TENANT_LEAVE_BALANCE_TO_DO',
  TenantVacated = 'TENANT_VACATED'
}

export type LeaseTenantBalance = {
  __typename: 'LeaseTenantBalance';
  currency: Currency;
  value: Scalars['Float'];
};

export type LeaseTenantInformation = {
  __typename: 'LeaseTenantInformation';
  customer: Customer;
  isMain: Scalars['Boolean'];
};

export type LeaseUnitInformation = {
  __typename: 'LeaseUnitInformation';
  isMain: Scalars['Boolean'];
  unit: Unit;
};

export type LeasesFiltersInput = {
  leaveDate?: InputMaybe<LeasesFiltersInputLeaveDate>;
  lessorAccountId?: InputMaybe<LeasesFiltersInputLessorAccountId>;
  or?: InputMaybe<Array<LeasesFiltersInput>>;
  status?: InputMaybe<LeaseFiltersInputStatus>;
};

export type LeasesFiltersInputLeaveDate = {
  eq?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LeasesFiltersInputLessorAccountId = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  neq?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type LeasesResponse = {
  __typename: 'LeasesResponse';
  edges: Array<LeaseEdge>;
  pageInfo: PageInfo;
};

export type LegalRepresentative = {
  __typename: 'LegalRepresentative';
  civility?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type LessorAccount = Account & {
  __typename: 'LessorAccount';
  buildings: Array<Building>;
  customer: Customer;
  expectedLessorPropertyTaxComputeProgress: ExpectedLessorPropertyTaxComputeProgress;
  expectedLessorPropertyTaxFiscalYears: Array<ExpectedLessorPropertyTaxFiscalYear>;
  expectedLessorPropertyTaxes: ExpectedLessorPropertyTaxesResponse;
  guides: Array<Guide>;
  hasRestrictedAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  managerId: Scalars['ID'];
  mandates: Array<RentalManagementMandate>;
  missionIncidents: MissionIncidentsResponse;
  number: Scalars['String'];
  propertyTaxFilingGuide: Guide;
  rentalSituationFile: RentalSituationFile;
};


export type LessorAccountExpectedLessorPropertyTaxComputeProgressArgs = {
  fiscalYear: Scalars['Int'];
};


export type LessorAccountExpectedLessorPropertyTaxesArgs = {
  cursor?: InputMaybe<CursorInput>;
};


export type LessorAccountMissionIncidentsArgs = {
  cursor?: InputMaybe<CursorInput>;
  sortBy?: InputMaybe<Array<MissionIncidentSortInput>>;
};

export type LessorPropertyTax = {
  __typename: 'LessorPropertyTax';
  areAllBuildingsManagedByAgency: Scalars['Boolean'];
  buildings: Array<LessorPropertyTaxBuilding>;
  fileId: Scalars['String'];
  fiscalManagementFees: Amount;
  fiscalYear: Scalars['Int'];
  id: Scalars['ID'];
  total: Amount;
};

export type LessorPropertyTaxBuilding = {
  __typename: 'LessorPropertyTaxBuilding';
  areAllUnitsManagedByAgency: Scalars['Boolean'];
  building: Building;
  totalContributionFees: Amount;
  wasteContributionFees: Amount;
};

export type LessorPropertyTaxBuildingInput = {
  areAllUnitsManagedByAgency: Scalars['Boolean'];
  buildingId: Scalars['ID'];
  totalContributionFees: AmountInput;
  wasteContributionFees: AmountInput;
};

export enum LessorPropertyTaxStatus {
  Discharged = 'DISCHARGED',
  DischargeError = 'DISCHARGE_ERROR',
  Invalid = 'INVALID',
  ReadyForDischarge = 'READY_FOR_DISCHARGE',
  Uploaded = 'UPLOADED'
}

export enum LessorPropertyTaxUploadUrlMimeType {
  ApplicationPdf = 'APPLICATION_PDF'
}

export type LoginCheckResponse = PermanentLoginResponse | TemporaryLoginResponse;

export type MissionIncident = {
  __typename: 'MissionIncident';
  building?: Maybe<Building>;
  createdAt: Scalars['String'];
  displayStatus: MissionIncidentDisplayStatus;
  hasWorkOrders: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Scalars['String'];
  number: Scalars['String'];
  startedAt: Scalars['String'];
  unit?: Maybe<Unit>;
  updatedAt: Scalars['String'];
};

export enum MissionIncidentDisplayStatus {
  Completed = 'COMPLETED',
  InterventionScheduled = 'INTERVENTION_SCHEDULED',
  RequestTransmitted = 'REQUEST_TRANSMITTED'
}

export type MissionIncidentEdge = {
  __typename: 'MissionIncidentEdge';
  node: MissionIncident;
};

export type MissionIncidentSortInput = {
  direction: SortDirectionEnum;
  key: MissionIncidentSortKeyEnum;
};

export enum MissionIncidentSortKeyEnum {
  Label = 'label',
  Number = 'number',
  StartedAt = 'startedAt',
  Status = 'status'
}

export type MissionIncidentsResponse = {
  __typename: 'MissionIncidentsResponse';
  edges: Array<MissionIncidentEdge>;
  pageInfo: PageInfo;
};

export type Mutation = {
  __typename: 'Mutation';
  computeExpectedLessorPropertyTax: Scalars['Boolean'];
  createPostalVoteDraft: PostalVoteDraft;
  startPostalVoteSignature: Scalars['Boolean'];
  subscribeEreco: Scalars['Boolean'];
  updateCustomerProfile: UpdatedCustomerProfile;
  updateHeatingCertificate: Scalars['Boolean'];
  updateInsuranceMultiriskUnit: Scalars['Boolean'];
  uploadLessorPropertyTax: LessorPropertyTax;
  upsertPostalVoteDraft: PostalVoteDraft;
};


export type MutationComputeExpectedLessorPropertyTaxArgs = {
  input: ComputeExpectedLessorPropertyTaxInput;
};


export type MutationCreatePostalVoteDraftArgs = {
  coOwnerAccountId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
  votes: Array<ResolutionVoteInput>;
};


export type MutationStartPostalVoteSignatureArgs = {
  brandCode: Scalars['String'];
  coOwnerAccountId: Scalars['ID'];
  customerId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
};


export type MutationSubscribeErecoArgs = {
  accountId: Scalars['ID'];
  customerId: Scalars['ID'];
};


export type MutationUpdateCustomerProfileArgs = {
  customerId: Scalars['ID'];
  payload: UpdateCustomerProfileInput;
};


export type MutationUpdateHeatingCertificateArgs = {
  customerId: Scalars['ID'];
  heatingCertificate: UpdateLeaseHeatingCertificateInput;
};


export type MutationUpdateInsuranceMultiriskUnitArgs = {
  customerId: Scalars['ID'];
  insuranceMultiriskUnit: UpdateLeaseInsuranceMultiriskUnitInput;
};


export type MutationUploadLessorPropertyTaxArgs = {
  lessorPropertyTax: CreateLessorPropertyTaxInput;
};


export type MutationUpsertPostalVoteDraftArgs = {
  coOwnerAccountId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
  vote: ResolutionVoteInput;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PermanentLoginResponse = {
  __typename: 'PermanentLoginResponse';
  isLoginWithOktaEnabled: Scalars['Boolean'];
};

export type PostalVoteDocument = {
  __typename: 'PostalVoteDocument';
  hashFile: Scalars['String'];
};

export type PostalVoteDraft = {
  __typename: 'PostalVoteDraft';
  coOwnerAccountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  generalAssemblyId: Scalars['ID'];
  id: Scalars['ID'];
  lastValidPostalVoteReceptionDate: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  votes: Array<PostalVoteDraftVote>;
};

export type PostalVoteDraftVote = {
  __typename: 'PostalVoteDraftVote';
  candidate?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isSecondVote: Scalars['Boolean'];
  resolutionId: Scalars['ID'];
  status: ResolutionVoteStatusResponseEnum;
};

export type Query = {
  __typename: 'Query';
  account: Account;
  accounts: AccountsResponse;
  brand: QueryBrandResult;
  building: Building;
  insuranceCompanies: Array<Scalars['String']>;
  leases: LeasesResponse;
  loginCheck: LoginCheckResponse;
  me: Authentication;
  postalVoteSignature: GetPostalVoteSignature;
  rentalSituationFile: RentalSituationFile;
  workOrders?: Maybe<CustomerPortalWorkOrdersResponse>;
};


export type QueryAccountArgs = {
  id: Scalars['ID'];
};


export type QueryAccountsArgs = {
  cursor?: InputMaybe<CursorInput>;
  filters?: InputMaybe<AccountFiltersInput>;
};


export type QueryBrandArgs = {
  code: Scalars['String'];
};


export type QueryBuildingArgs = {
  id: Scalars['ID'];
};


export type QueryLeasesArgs = {
  cursor?: InputMaybe<CursorInput>;
  filters: LeasesFiltersInput;
};


export type QueryLoginCheckArgs = {
  login: Scalars['String'];
};


export type QueryPostalVoteSignatureArgs = {
  missionId: Scalars['ID'];
};


export type QueryRentalSituationFileArgs = {
  lessorAccountId: Scalars['ID'];
};


export type QueryWorkOrdersArgs = {
  accountId: Scalars['ID'];
  cursor?: InputMaybe<CursorInput>;
  missionId: Scalars['ID'];
};

export type QueryBrandResult = BrandNotFoundError | QueryBrandSuccess;

export type QueryBrandSuccess = {
  __typename: 'QueryBrandSuccess';
  data: Brand;
};

export type RegisteredEmail = {
  __typename: 'RegisteredEmail';
  hasHistory: Scalars['Boolean'];
  isSubscribed: Scalars['Boolean'];
};

export type RentalManagementMandate = {
  __typename: 'RentalManagementMandate';
  id: Scalars['ID'];
  units: Array<RentalManagementMandateUnitInformation>;
};

export type RentalManagementMandateUnitInformation = {
  __typename: 'RentalManagementMandateUnitInformation';
  unit: Unit;
};

export type RentalSituationFile = {
  __typename: 'RentalSituationFile';
  fileId: Scalars['ID'];
};

export type ResolutionVoteInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  isSecondVote: Scalars['Boolean'];
  resolutionId: Scalars['ID'];
  status: ResolutionVoteStatusRequestEnum;
};

export enum ResolutionVoteStatusRequestEnum {
  Abstention = 'ABSTENTION',
  Contre = 'CONTRE',
  Pour = 'POUR'
}

export enum ResolutionVoteStatusResponseEnum {
  Abstention = 'ABSTENTION',
  Contre = 'CONTRE',
  Defaillance = 'DEFAILLANCE',
  Pour = 'POUR'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TemporaryLoginResponse = {
  __typename: 'TemporaryLoginResponse';
  agencyEmail: Scalars['String'];
  agencyPhone: Scalars['String'];
  anonymizedEmail: Scalars['String'];
  redirectUrl: Scalars['String'];
  token: Scalars['String'];
};

export type TenantAccount = Account & {
  __typename: 'TenantAccount';
  building: Building;
  customer: Customer;
  guides: Array<Guide>;
  hasFutureLeaseEntryDate: Scalars['Boolean'];
  hasFutureLeaseStartDate: Scalars['Boolean'];
  hasRestrictedAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  lease: Lease;
  managerId: Scalars['ID'];
  missionIncidents: MissionIncidentsResponse;
  number: Scalars['String'];
  units: Array<Unit>;
};


export type TenantAccountMissionIncidentsArgs = {
  cursor?: InputMaybe<CursorInput>;
  sortBy?: InputMaybe<Array<MissionIncidentSortInput>>;
};

export type Unit = {
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export type UnitApartment = Unit & {
  __typename: 'UnitApartment';
  building: Building;
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  subType: UnitSubTypeEnum;
  unitNumber: Scalars['String'];
};

export type UnitHousing = Unit & {
  __typename: 'UnitHousing';
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  subType: UnitSubTypeEnum;
  unitNumber: Scalars['String'];
};

export type UnitIslet = Unit & {
  __typename: 'UnitIslet';
  building: Building;
  category: Scalars['String'];
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export type UnitLand = Unit & {
  __typename: 'UnitLand';
  category: Scalars['String'];
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export type UnitOther = Unit & {
  __typename: 'UnitOther';
  building: Building;
  category: Scalars['String'];
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export type UnitParking = Unit & {
  __typename: 'UnitParking';
  building: Building;
  category: Scalars['String'];
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export type UnitProfessionalRetailer = Unit & {
  __typename: 'UnitProfessionalRetailer';
  category: Scalars['String'];
  coOwnershipBylawsId: Scalars['String'];
  id: Scalars['ID'];
  unitNumber: Scalars['String'];
};

export enum UnitSubTypeEnum {
  Nc = 'NC',
  T1 = 'T1',
  T1Bis = 'T1_BIS',
  T2 = 'T2',
  T2Bis = 'T2_BIS',
  T3 = 'T3',
  T3Bis = 'T3_BIS',
  T4 = 'T4',
  T5 = 'T5',
  T6 = 'T6',
  T7 = 'T7',
  T8 = 'T8',
  T9 = 'T9',
  T10 = 'T10',
  T11 = 'T11',
  T12 = 'T12',
  T13 = 'T13',
  T14 = 'T14',
  T15 = 'T15',
  T16 = 'T16',
  T17 = 'T17',
  T18 = 'T18',
  T19 = 'T19',
  T20 = 'T20',
  T21 = 'T21',
  T22 = 'T22',
  T23 = 'T23',
  T24 = 'T24',
  T25 = 'T25',
  T26 = 'T26',
  T27 = 'T27',
  T28 = 'T28',
  T29 = 'T29',
  T30 = 'T30'
}

export type UpdateCustomerProfileBirthInput = {
  date?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerProfileInput = {
  birth?: InputMaybe<UpdateCustomerProfileBirthInput>;
  email?: InputMaybe<Scalars['String']>;
  familyStatus?: InputMaybe<FamilyStatus>;
  landlinePhone?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
};

export type UpdateLeaseHeatingCertificateInput = {
  draftId: Scalars['String'];
  end: Scalars['DateTime'];
  leaseId: Scalars['ID'];
  start: Scalars['DateTime'];
};

export type UpdateLeaseInsuranceMultiriskUnitInput = {
  companyName: Scalars['String'];
  draftId: Scalars['String'];
  leaseId: Scalars['ID'];
  policyNumber: Scalars['String'];
  start: Scalars['DateTime'];
};

export type UpdatedCustomerProfile = {
  __typename: 'UpdatedCustomerProfile';
  birth?: Maybe<UpdatedCustomerProfileBirth>;
  email?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<FamilyStatus>;
  id: Scalars['ID'];
  landlinePhone?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
};

export type UpdatedCustomerProfileBirth = {
  __typename: 'UpdatedCustomerProfileBirth';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
};

export type SubscribeErecoMutationVariables = Exact<{
  accountId: Scalars['ID'];
  customerId: Scalars['ID'];
}>;


export type SubscribeErecoMutation = { __typename: 'Mutation', subscribeEreco: boolean };

export type LoginCheckQueryVariables = Exact<{
  login: Scalars['String'];
}>;


export type LoginCheckQuery = { __typename: 'Query', loginCheck: { __typename: 'PermanentLoginResponse', isLoginWithOktaEnabled: boolean } | { __typename: 'TemporaryLoginResponse', redirectUrl: string, anonymizedEmail: string, token: string, agencyEmail: string, agencyPhone: string } };

export type GetBrandQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetBrandQuery = { __typename: 'Query', brand: { __typename: 'BrandNotFoundError', message: string, code: string } | { __typename: 'QueryBrandSuccess', data: { __typename: 'Brand', id: string, code: string, identity: { __typename: 'BrandIdentity', name: string, logoUrl: string }, dataProtectionPolicy: { __typename: 'BrandDataProtectionPolicy', email: string, url: string }, customerPortal: { __typename: 'CustomerPortal', name: string, url: string, displayUrl: string, logoUrl: string, assistance?: { __typename: 'BrandCustomerPortalAssistance', phone: string, hours: string } | null, guides?: { __typename: 'BrandCustomerPortalGuides', trusteeCouncilGuideUrl?: string | null, userGuides?: { __typename: 'BrandCustomerPortalUserGuides', categoryName: string, documents?: Array<{ __typename: 'BrandCustomerPortalGuideDocument', url: string, originalFilename: string, mimeType: string, qualities: Array<AccountQualityEnum> }> | null } | null, propertyTaxFillingGuide?: { __typename: 'BrandCustomerPortalGuideDocument', url: string, originalFilename: string, mimeType: string, qualities: Array<AccountQualityEnum> } | null } | null }, registeredEmailService?: { __typename: 'BrandRegisteredEmailService', name: string } | null, payment: { __typename: 'BrandPayment', hasAutomaticDirectDebit: boolean, hasOnDemandDirectDebit: boolean } } } };

export type GetBuildingPricingsQueryVariables = Exact<{
  id: Scalars['ID'];
  coOwnershipMandateId: Scalars['String'];
}>;


export type GetBuildingPricingsQuery = { __typename: 'Query', building: { __typename: 'Building', pricings: Array<{ __typename: 'BuildingPricing', codification: string, amount?: { __typename: 'AmountVAT', currency: Currency, vatRate: number, taxExcluded: number, taxIncluded: number } | null }> } };

export type UpdateCustomerProfileMutationVariables = Exact<{
  customerId: Scalars['ID'];
  payload: UpdateCustomerProfileInput;
}>;


export type UpdateCustomerProfileMutation = { __typename: 'Mutation', updateCustomerProfile: { __typename: 'UpdatedCustomerProfile', email?: string | null, familyStatus?: FamilyStatus | null, landlinePhone?: string | null, mobilePhone?: string | null, birth?: { __typename: 'UpdatedCustomerProfileBirth', date?: any | null } | null } };

export type MissionIncidentFieldsFragment = { __typename: 'MissionIncident', id: string, number: string, startedAt: string, label: string, displayStatus: MissionIncidentDisplayStatus, hasWorkOrders: boolean };

export type CustomerPortalWorkOrderFieldsFragment = { __typename: 'CustomerPortalWorkOrder', id: string, number: string, label: string, repairDate?: { __typename: 'CustomerPortalWorkOrderRepairDate', start: string, end: string } | null, supplier?: { __typename: 'CustomerPortalWorkOrderSupplier', id: string, number?: string | null, fullName?: string | null, activity?: string | null } | null };

export type GetInsuranceCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceCompaniesQuery = { __typename: 'Query', insuranceCompanies: Array<string> };

export type UpdateHeatingCertificateMutationVariables = Exact<{
  customerId: Scalars['ID'];
  heatingCertificate: UpdateLeaseHeatingCertificateInput;
}>;


export type UpdateHeatingCertificateMutation = { __typename: 'Mutation', updateHeatingCertificate: boolean };

export type UpdateInsuranceMultiriskUnitMutationVariables = Exact<{
  customerId: Scalars['ID'];
  insuranceMultiriskUnit: UpdateLeaseInsuranceMultiriskUnitInput;
}>;


export type UpdateInsuranceMultiriskUnitMutation = { __typename: 'Mutation', updateInsuranceMultiriskUnit: boolean };

export type GetLeasesQueryVariables = Exact<{
  filters: LeasesFiltersInput;
  cursor?: InputMaybe<CursorInput>;
}>;


export type GetLeasesQuery = { __typename: 'Query', leases: { __typename: 'LeasesResponse', edges: Array<{ __typename: 'LeaseEdge', node: { __typename: 'Lease', id: string, entryDate?: any | null, leaveDate?: any | null, tenants: Array<{ __typename: 'LeaseTenantInformation', isMain: boolean, customer: { __typename: 'CustomerCompany', companyName?: string | null, id: string } | { __typename: 'CustomerPerson', lastName: string, firstName: string, id: string } }>, units: Array<{ __typename: 'LeaseUnitInformation', isMain: boolean, unit: { __typename: 'UnitApartment', subType: UnitSubTypeEnum, coOwnershipBylawsId: string } | { __typename: 'UnitHousing', subType: UnitSubTypeEnum, coOwnershipBylawsId: string } | { __typename: 'UnitIslet', category: string, coOwnershipBylawsId: string } | { __typename: 'UnitLand', category: string, coOwnershipBylawsId: string } | { __typename: 'UnitOther', category: string, coOwnershipBylawsId: string } | { __typename: 'UnitParking', category: string, coOwnershipBylawsId: string } | { __typename: 'UnitProfessionalRetailer', category: string, coOwnershipBylawsId: string } }>, building?: { __typename: 'Building', address: { __typename: 'Address', address1: string, zipCode: string, city: string, country?: string | null } } | null, tenantBalance?: { __typename: 'LeaseTenantBalance', value: number, currency: Currency } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetRentalSituationFileQueryVariables = Exact<{
  lessorAccountId: Scalars['ID'];
}>;


export type GetRentalSituationFileQuery = { __typename: 'Query', rentalSituationFile: { __typename: 'RentalSituationFile', fileId: string } };

export type GetMissionIncidentsQueryVariables = Exact<{
  id: Scalars['ID'];
  cursor?: InputMaybe<CursorInput>;
  sortBy?: InputMaybe<Array<MissionIncidentSortInput> | MissionIncidentSortInput>;
}>;


export type GetMissionIncidentsQuery = { __typename: 'Query', account: { __typename: 'CoOwnerAccount', id: string, missionIncidents: { __typename: 'MissionIncidentsResponse', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'MissionIncidentEdge', node: { __typename: 'MissionIncident', id: string, number: string, startedAt: string, label: string, displayStatus: MissionIncidentDisplayStatus, hasWorkOrders: boolean } }> } } | { __typename: 'LessorAccount', id: string, missionIncidents: { __typename: 'MissionIncidentsResponse', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'MissionIncidentEdge', node: { __typename: 'MissionIncident', id: string, number: string, startedAt: string, label: string, displayStatus: MissionIncidentDisplayStatus, hasWorkOrders: boolean } }> } } | { __typename: 'TenantAccount', id: string, missionIncidents: { __typename: 'MissionIncidentsResponse', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'MissionIncidentEdge', node: { __typename: 'MissionIncident', id: string, number: string, startedAt: string, label: string, displayStatus: MissionIncidentDisplayStatus, hasWorkOrders: boolean } }> } } };

export type GetWorkOrdersQueryVariables = Exact<{
  missionId: Scalars['ID'];
  accountId: Scalars['ID'];
  cursor?: InputMaybe<CursorInput>;
}>;


export type GetWorkOrdersQuery = { __typename: 'Query', workOrders?: { __typename: 'CustomerPortalWorkOrdersResponse', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'CustomerPortalWorkOrderEdge', node: { __typename: 'CustomerPortalWorkOrder', id: string, number: string, label: string, repairDate?: { __typename: 'CustomerPortalWorkOrderRepairDate', start: string, end: string } | null, supplier?: { __typename: 'CustomerPortalWorkOrderSupplier', id: string, number?: string | null, fullName?: string | null, activity?: string | null } | null } }> } | null };

export type CreatePostalVoteDraftMutationVariables = Exact<{
  coOwnerAccountId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
  votes: Array<ResolutionVoteInput> | ResolutionVoteInput;
}>;


export type CreatePostalVoteDraftMutation = { __typename: 'Mutation', createPostalVoteDraft: { __typename: 'PostalVoteDraft', id: string, coOwnerAccountId: string, generalAssemblyId: string, votes: Array<{ __typename: 'PostalVoteDraftVote', id: string, status: ResolutionVoteStatusResponseEnum, resolutionId: string, candidate?: string | null, isSecondVote: boolean }> } };

export type GetPostalVoteSignatureQueryVariables = Exact<{
  generalAssemblyId: Scalars['ID'];
}>;


export type GetPostalVoteSignatureQuery = { __typename: 'Query', postalVoteSignature: { __typename: 'GetPostalVoteSignature', signUrl?: string | null, transactionId?: string | null } };

export type StartPostalVoteSignatureMutationVariables = Exact<{
  coOwnerAccountId: Scalars['ID'];
  customerId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
  brandCode: Scalars['String'];
}>;


export type StartPostalVoteSignatureMutation = { __typename: 'Mutation', startPostalVoteSignature: boolean };

export type UpsertPostalVoteDraftMutationVariables = Exact<{
  coOwnerAccountId: Scalars['ID'];
  generalAssemblyId: Scalars['ID'];
  vote: ResolutionVoteInput;
}>;


export type UpsertPostalVoteDraftMutation = { __typename: 'Mutation', upsertPostalVoteDraft: { __typename: 'PostalVoteDraft', id: string, coOwnerAccountId: string, generalAssemblyId: string, votes: Array<{ __typename: 'PostalVoteDraftVote', id: string, status: ResolutionVoteStatusResponseEnum, resolutionId: string, candidate?: string | null, isSecondVote: boolean }> } };
